"use client";

import { useState, type ReactNode } from "react";

interface SmartImageProps {
  src: string;
  alt: string;
  className?: string;
  fallback: ReactNode;
}

/**
 * Renders an external thumbnail with graceful fallback to
 * decorative artwork when the URL is missing or fails to load.
 */
export function SmartImage({ src, alt, className, fallback }: SmartImageProps) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) return <>{fallback}</>;

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
